import {Component} from '@angular/core';
import {DialogService, NotificationService} from '../services';
import {BaseComponent} from '@wms/components';
import {CommonModule} from '@angular/common';
import {PageWsService} from '../workspace';
import {PrefabPublishService} from './prefab-publish.service';
import {WmsFeatureDirective} from '../directives';
import {handleInvalidRepoBranch} from "@wms/core";

@Component({
  selector: 'wms-prefab-publish',
  templateUrl: './prefab-publish.component.html',
  styleUrls: ['./prefab-publish.component.less'],
  standalone: true,
  imports: [CommonModule, WmsFeatureDirective]
})
export class PrefabPublishComponent extends BaseComponent {
  protected projectDetails: any;
  protected projectEdnDetails: any;
  constructor(
    private dialogService: DialogService,
    private pageWorkspaceManager: PageWsService,
    private notificationService: NotificationService,
    private prefabPublishService: PrefabPublishService
  ) {
    super();
    this.projectEdnDetails = this.projectService.getProjectEdnDetails();
    this.projectDetails = this.projectService.getDetails();
  }

  publishPrefabToTeam() {
    this.prefabPublishService.publishPrefabToTeam()
  }

  publishPrefabToWorkspace() {
    this.prefabPublishService.publishPrefabToWorkSpace()
  }
  publishPrefabToProject() {
    this.pageWorkspaceManager.saveActiveTabContent(false).then(() => {
      this.prefabPublishService.getProjects();
    }).catch(() => {
      this.notificationService.show(
        'error',
        this.locale['MESSAGE_ERROR_TITLE'],
        this.locale['MESSAGE_ERROR_SAVE_FILE_DESC']
      );
    })
  }

  publishPrefab(type:string) {
    if (handleInvalidRepoBranch()) return;

    switch (type) {
      case 'project':
        this.publishPrefabToProject();
        break;
      case 'workspace':
        this.publishPrefabToWorkspace();
        break;
      case 'team':
        this.publishPrefabToTeam();
        break;
      default:
        break;
      }
  }

  openDialogWithId(id: string): void {
    this.dialogService.open(id);
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
  }

}
